export default __webpack_public_path__ + "static/je-a8c167658e44f2a07b32f7b6faa813f1.svg";